/**
 * Relax Detail front end: header and phone menu, the garage-door intro, the film, scroll reveals,
 * the stacking service panels, the How it works pictures, the photo viewer and the service-area map.
 * Ported from the approved Garage concept. Settings come from window.rdData (inc/rd.php).
 *
 * @package Relax_Detail
 */

( function () {
	'use strict';

	var D = window.rdData || {};
	var body = document.body;
	var reduce = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
	var touch = window.matchMedia( '(hover: none), (pointer: coarse)' ).matches;
	var phone = window.matchMedia( '(max-width: 860px)' ).matches;
	var $ = function ( s, r ) { return ( r || document ).querySelector( s ); };
	var $$ = function ( s, r ) { return [].slice.call( ( r || document ).querySelectorAll( s ) ); };
	var lenis = null;

	function el( tag, cls, html ) {
		var e = document.createElement( tag );
		if ( cls ) { e.className = cls; }
		if ( html ) { e.innerHTML = html; }
		return e;
	}

	/* ---------- Smooth scroll: Lenis on GSAP's ticker, mouse and trackpad only ---------- */
	function startLenis() {
		if ( reduce || touch || ! window.Lenis || ! window.gsap ) { return; }
		lenis = new window.Lenis( { lerp: 0.1, wheelMultiplier: 1 } );
		if ( window.ScrollTrigger ) { lenis.on( 'scroll', window.ScrollTrigger.update ); }
		window.gsap.ticker.add( function ( t ) { lenis.raf( t * 1000 ); } );
		window.gsap.ticker.lagSmoothing( 0 );
		window.relaxLenis = lenis;
	}

	function offset() { return phone ? 68 : 76; }

	function anchors() {
		document.addEventListener( 'click', function ( e ) {
			var a = e.target.closest( 'a[href*="#"]' );
			if ( ! a || a.origin !== location.origin || a.pathname !== location.pathname ) { return; }
			var id = a.hash;
			var t = id.length > 1 && document.getElementById( id.slice( 1 ) );
			if ( ! t ) { return; }
			e.preventDefault();
			if ( lenis ) { lenis.scrollTo( t, { offset: -offset() } ); } else { window.scrollTo( { top: t.getBoundingClientRect().top + window.scrollY - offset(), behavior: reduce ? 'auto' : 'smooth' } ); }
			history.replaceState( null, '', id );
		} );
	}

	/* ---------- Header: dropdowns from the menu lists, then the phone menu ---------- */
	function header() {
		var hd = $( '.hd' );
		if ( ! hd ) { return; }
		var here = location.href.split( '#' )[ 0 ];
		var gs = !! window.gsap && ! reduce;
		$$( '.nav-link, .sub-link', hd ).forEach( function ( a ) { if ( a.href === here ) { a.setAttribute( 'aria-current', 'page' ); } } );

		var drops = [];
		$$( '.nav-btn', hd ).forEach( function ( b ) {
			var slug = ( b.id || '' ).replace( /^nav-/, '' );
			var panel = document.getElementById( 'mega-' + slug );
			if ( ! panel ) { return; }
			b.setAttribute( 'role', 'button' );
			b.setAttribute( 'aria-haspopup', 'true' );
			b.setAttribute( 'aria-expanded', 'false' );
			b.setAttribute( 'aria-controls', panel.id );
			drops.push( { b: b, p: panel } );
			function place() { panel.style.left = ( b.offsetLeft ) + 'px'; }
			function set( open ) {
				drops.forEach( function ( d ) {
					var on = open && d.b === b;
					d.b.setAttribute( 'aria-expanded', on ? 'true' : 'false' );
					d.p.classList.toggle( 'is-open', on );
				} );
				if ( open ) { place(); }
			}
			b.addEventListener( 'click', function ( e ) { e.preventDefault(); set( b.getAttribute( 'aria-expanded' ) !== 'true' ); } );
			if ( ! touch ) {
				var li = [ b, panel ];
				var timer = 0;
				li.forEach( function ( n ) {
					n.addEventListener( 'pointerenter', function () { clearTimeout( timer ); set( true ); } );
					n.addEventListener( 'pointerleave', function () { timer = setTimeout( function () { if ( ! panel.contains( document.activeElement ) ) { set( false ); } }, 160 ); } );
				} );
			}
			panel.addEventListener( 'focusout', function ( e ) { if ( ! panel.contains( e.relatedTarget ) && e.relatedTarget !== b ) { set( false ); } } );
		} );
		document.addEventListener( 'click', function ( e ) { if ( ! e.target.closest( '.links' ) ) { drops.forEach( function ( d ) { d.b.setAttribute( 'aria-expanded', 'false' ); d.p.classList.remove( 'is-open' ); } ); } } );
		document.addEventListener( 'keydown', function ( e ) {
			if ( e.key !== 'Escape' ) { return; }
			drops.forEach( function ( d ) { if ( d.p.classList.contains( 'is-open' ) ) { d.p.classList.remove( 'is-open' ); d.b.setAttribute( 'aria-expanded', 'false' ); d.b.focus(); } } );
		} );

		// Phone menu, built from the same lists so Appearance > Menus drives both.
		var burger = el( 'button', 'burger', '<span></span><span></span>' );
		burger.type = 'button';
		burger.setAttribute( 'aria-expanded', 'false' );
		burger.setAttribute( 'aria-controls', 'rd-menu' );
		burger.setAttribute( 'aria-label', 'Open menu' );
		hd.appendChild( burger );
		var menu = el( 'div', 'menu' );
		menu.id = 'rd-menu';
		menu.setAttribute( 'aria-label', 'Menu' );
		menu.setAttribute( 'inert', '' );
		var ul = el( 'ul' );
		$$( '.nav-list > *', hd ).forEach( function ( item, i ) {
			var li = el( 'li' );
			var panel = item.classList.contains( 'nav-btn' ) && document.getElementById( 'mega-' + item.id.replace( /^nav-/, '' ) );
			if ( panel ) {
				var row = el( 'div', 'menu-row' );
				var a = el( 'a' );
				a.href = item.getAttribute( 'href' ) || '#';
				a.textContent = item.textContent.trim();
				var tg = el( 'button', 'menu-tg' );
				tg.type = 'button';
				tg.setAttribute( 'aria-expanded', 'false' );
				tg.setAttribute( 'aria-controls', 'm-sub-' + i );
				tg.setAttribute( 'aria-label', 'Show ' + a.textContent + ' links' );
				var sub = el( 'div', 'menu-sub' );
				sub.id = 'm-sub-' + i;
				sub.hidden = true;
				$$( '.sub-link', panel ).forEach( function ( s ) { var x = el( 'a' ); x.href = s.href; x.textContent = s.textContent.trim(); sub.appendChild( x ); } );
				tg.addEventListener( 'click', function () {
					var o = tg.getAttribute( 'aria-expanded' ) !== 'true';
					tg.setAttribute( 'aria-expanded', o ? 'true' : 'false' );
					if ( ! gs ) { sub.hidden = ! o; return; }
					// The list slides open from its own height and its links rise after it; closing folds it away.
					var g = window.gsap;
					g.killTweensOf( sub );
					if ( o ) {
						sub.hidden = false;
						g.fromTo( sub, { height: 0 }, { height: 'auto', duration: 0.5, ease: 'power3.out', clearProps: 'height' } );
						g.fromTo( sub.children, { y: 14, opacity: 0 }, { y: 0, opacity: 1, duration: 0.45, ease: 'power3.out', stagger: 0.04, delay: 0.06 } );
					} else {
						g.to( sub, { height: 0, duration: 0.35, ease: 'power3.inOut', onComplete: function () { sub.hidden = true; sub.style.height = ''; } } );
					}
				} );
				row.appendChild( a );
				row.appendChild( tg );
				li.appendChild( row );
				li.appendChild( sub );
			} else {
				var b = el( 'a' );
				b.href = item.href;
				b.textContent = item.textContent.trim();
				li.appendChild( b );
			}
			ul.appendChild( li );
		} );
		menu.appendChild( ul );
		var foot = el( 'div', 'menu-foot' );
		var q = $( '.hd-quote', hd );
		if ( q ) { var qb = el( 'a', 'btn btn-gold btn-arrow' ); qb.href = q.href; qb.textContent = q.textContent.trim(); foot.appendChild( qb ); }
		var call = $( '.hd-call', hd );
		if ( call ) { var cb = el( 'a', 'btn btn-line menu-call' ); cb.href = call.href; cb.textContent = call.textContent.trim(); foot.appendChild( cb ); }
		menu.appendChild( foot );
		$$( 'a', menu ).forEach( function ( a ) { if ( a.href === here ) { a.setAttribute( 'aria-current', 'page' ); } } );
		document.body.appendChild( menu );
		// Open: the panel wipes down, then each row rises in turn, then the two buttons. Close plays it back
		// faster. Without GSAP, or under reduced motion, the CSS clip-path transition does it alone.
		var tl = null;
		if ( gs ) {
			menu.classList.add( 'menu--gs' );
			tl = window.gsap.timeline( { paused: true, onReverseComplete: function () { menu.style.visibility = 'hidden'; } } )
				.set( menu, { visibility: 'visible' } )
				.fromTo( menu, { clipPath: 'inset(0% 0% 100% 0%)' }, { clipPath: 'inset(0% 0% 0% 0%)', duration: 0.7, ease: 'power3.inOut' } )
				.fromTo( $$( ':scope > ul > li', menu ), { y: 32, opacity: 0 }, { y: 0, opacity: 1, duration: 0.65, ease: 'power3.out', stagger: 0.07 }, '-=0.32' )
				.fromTo( foot.children, { y: 20, opacity: 0 }, { y: 0, opacity: 1, duration: 0.55, ease: 'power3.out', stagger: 0.08 }, '-=0.45' );
		}
		function set( open ) {
			menu.classList.toggle( 'open', open );
			if ( tl ) { if ( open ) { tl.timeScale( 1 ).play(); } else { tl.timeScale( 1.7 ).reverse(); } }
			if ( open ) { menu.removeAttribute( 'inert' ); } else { menu.setAttribute( 'inert', '' ); }
			burger.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
			burger.setAttribute( 'aria-label', open ? 'Close menu' : 'Open menu' );
			if ( lenis ) { lenis[ open ? 'stop' : 'start' ](); }
			document.documentElement.style.overflow = open ? 'hidden' : '';
		}
		burger.addEventListener( 'click', function () { set( ! menu.classList.contains( 'open' ) ); } );
		menu.addEventListener( 'click', function ( e ) { if ( e.target.closest( 'a' ) ) { set( false ); } } );
		document.addEventListener( 'keydown', function ( e ) { if ( e.key === 'Escape' && menu.classList.contains( 'open' ) ) { set( false ); burger.focus(); } } );
	}

	/* ---------- The garage door: once per visit, on the home page ---------- */
	function door() {
		var film = $( '.film' );
		var seen = false;
		try { seen = sessionStorage.getItem( 'rd-door' ) === '1'; } catch ( e ) {}
		if ( ! film || reduce || seen || ! window.gsap || ! D.logo ) { body.classList.add( 'opened' ); return; }
		try { sessionStorage.setItem( 'rd-door', '1' ); } catch ( e ) {}
		var d = el( 'div', 'door', '<i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><span class="door-logo"><img alt="" width="300" height="158"></span><span class="door-handle"></span>' );
		d.setAttribute( 'aria-hidden', 'true' );
		$( 'img', d ).src = D.logo;
		body.appendChild( d );
		body.classList.add( 'door-on' );
		if ( lenis ) { lenis.stop(); }
		function opened() {
			body.classList.add( 'opened' );
			if ( d ) { d.remove(); }
			d = null;
			if ( lenis ) { lenis.start(); }
		}
		window.gsap.to( d, { yPercent: -100, duration: 1.3, ease: 'power3.inOut', delay: 0.35, onComplete: opened } );
		window.gsap.to( $$( 'i', d ), { yPercent: function ( i ) { return -6 * ( 8 - i ); }, duration: 1.3, ease: 'power3.inOut', delay: 0.35 } );
		setTimeout( function () { body.classList.add( 'opened' ); }, 1250 );
		setTimeout( function () { if ( d ) { opened(); } }, 3500 );
	}

	/* ---------- Film: chapters get their frame ranges, the headline is split into lines ---------- */
	function film() {
		var section = $( '.film' );
		if ( ! section ) { return; }
		section.setAttribute( 'aria-label', 'A full detail, from arrival to finished car' );
		var ranges = [ [ 1, 14 ], [ 16, 40 ], [ 48, 96 ], [ 104, 134 ], [ 146, 174 ], [ 180, 214 ], [ 224, 241 ] ];
		$$( '.ch', section ).forEach( function ( c, i ) {
			var r = ranges[ i ] || ranges[ ranges.length - 1 ];
			c.setAttribute( 'data-chapter', '' );
			c.dataset.from = r[ 0 ];
			c.dataset.to = r[ 1 ];
		} );
		var h1 = $( '.h1', section );
		if ( h1 && ! $( '.ln', h1 ) ) {
			h1.setAttribute( 'aria-label', h1.textContent.replace( /\s+/g, ' ' ).trim() );
			var parts = h1.innerHTML.split( /<br\s*\/?>/i );
			h1.innerHTML = parts.map( function ( p ) { return '<span class="ln" aria-hidden="true"><span>' + p.trim() + '</span></span>'; } ).join( '' );
		}
		var canvas = el( 'canvas', 'rs-canvas' );
		canvas.setAttribute( 'role', 'img' );
		canvas.setAttribute( 'aria-label', 'Film of a grey Mercedes being foamed, rinsed, cleaned inside, polished and coated on a driveway' );
		var poster = $( '.film-poster', section );
		if ( poster && poster.nextSibling ) { section.insertBefore( canvas, poster.nextSibling ); } else { section.appendChild( canvas ); }
		if ( ! window.RelaxScrub || ! D.film ) { return; }
		body.classList.add( 'rs-on' );
		var len = phone ? 5 : 7, hold = 1;
		var rail = filmRail( section, len, hold );
		// Big screens get the full-size frames; phones keep the lighter 1600 px set.
		var need = Math.max( window.innerWidth, window.innerHeight * 1.8 ) * Math.min( window.devicePixelRatio || 1, 2 );
		var base = ! phone && D.film.hd && need > 1700 ? D.film.hd : D.film.base;
		window.RelaxScrub.init( {
			section: section,
			frames: D.film.frames,
			staticFrame: 236,
			path: function ( i ) { return base + 'f_' + String( i ).padStart( 4, '0' ) + D.film.ext; },
			length: len,
			focal: [ [ 1, 0.5 ], [ 56, 0.6 ], [ 100, 0.55 ], [ 140, 0.6 ], [ 222, 0.5 ] ],
			blend: true,
			scrub: 0.6,
			hold: hold,
			onFrame: function ( f ) { if ( rail ) { rail( f ); } }
		} );
		// The next section rises over the last frame instead of the film scrolling away into a dark band.
		var host = section.parentElement && section.parentElement.classList.contains( 'pin-spacer' ) ? section.parentElement : section;
		var next = host.nextElementSibling;
		while ( next && ! next.matches( 'section' ) ) { next = next.nextElementSibling; }
		if ( next && window.gsap && ! reduce ) {
			next.classList.add( 'rd-cover' );
			// Only CSS variables on the section: the chapters keep their own is-active switching.
			window.gsap.fromTo( section, { '--film-dim': 0 }, { '--film-dim': 0.55, ease: 'none', immediateRender: false, scrollTrigger: { trigger: next, start: 'top bottom', end: 'top top', scrub: true } } );
			window.gsap.fromTo( section, { '--ch-hide': 0 }, { '--ch-hide': 1, ease: 'none', immediateRender: false, scrollTrigger: { trigger: next, start: 'top 45%', end: 'top 15%', scrub: true } } );
		}
	}

	/* ---------- Film rail: a stop per chapter on the right edge, as on the Smile Care services tour ----------
	   The chapter on screen shows its name; a click scrolls the pinned film to the middle of that chapter.
	   Returns the function the film calls with each frame, or null when the film does not scroll (reduced motion). */
	function filmRail( section, len, hold ) {
		if ( reduce || ! window.ScrollTrigger ) { return null; }
		var nav = el( 'nav', 'ch-rail' );
		nav.setAttribute( 'aria-label', 'Film chapters' );
		var stops = $$( '.ch', section ).map( function ( c ) {
			var b = el( 'button', '', '<span></span>' );
			var name = $( '.ch-svc', c );
			b.type = 'button';
			b.firstChild.textContent = name ? name.textContent.trim() : 'Arrival';
			b.addEventListener( 'click', function () {
				var st = window.ScrollTrigger.getAll().filter( function ( t ) { return t.pin === section; } )[ 0 ];
				if ( ! st ) { return; }
				var from = +c.dataset.from, mid = ( from + +c.dataset.to ) / 2;
				// Frame to scroll progress: the inverse of scrub.js, where the last `hold` screens stay on the last frame.
				var p = from === 1 ? 0 : ( mid - 1 ) / ( D.film.frames - 1 ) * len / ( len + hold );
				var y = st.start + p * ( st.end - st.start );
				if ( window.relaxLenis ) { window.relaxLenis.scrollTo( y, { duration: 1.4 } ); } else { window.scrollTo( { top: y, behavior: 'smooth' } ); }
			} );
			nav.appendChild( b );
			return { from: +c.dataset.from, el: b };
		} );
		if ( ! stops.length ) { return null; }
		section.appendChild( nav );
		// Between two chapters the last one passed stays marked.
		function mark( f ) {
			var on = 0;
			stops.forEach( function ( s, i ) { if ( f >= s.from ) { on = i; } } );
			stops.forEach( function ( s, i ) { if ( i === on ) { s.el.setAttribute( 'aria-current', 'step' ); } else { s.el.removeAttribute( 'aria-current' ); } } );
		}
		mark( 1 );
		return mark;
	}

	/* ---------- Reveals: curtains on the main photos, rising bands, tiles ---------- */
	function reveals() {
		// Curtain on the main pictures only: a panel in the section's ground and a gold one under it
		// draw aside, and the picture settles from a slight zoom.
		var slatted = $$( '.ph, .hero-photo, .photo, .card-img' );
		slatted.forEach( function ( p ) {
			if ( $( '.curtain', p ) ) { return; }
			var s = el( 'span', 'curtain', '<i></i><i></i>' );
			s.setAttribute( 'aria-hidden', 'true' );
			p.appendChild( s );
		} );
		$$( '.band' ).forEach( function ( b ) { b.classList.add( 'rise' ); } );
		var seen = slatted.concat( $$( '.band, .tiles' ) );
		if ( reduce || ! ( 'IntersectionObserver' in window ) ) {
			seen.forEach( function ( e ) { e.classList.add( 'in' ); } );
			return;
		}
		body.classList.add( 'js-motion' );
		var io = new IntersectionObserver( function ( es ) {
			es.forEach( function ( e ) { if ( e.isIntersecting ) { e.target.classList.add( 'in' ); io.unobserve( e.target ); } } );
		}, { rootMargin: '0px 0px -12% 0px' } );
		seen.forEach( function ( e ) { io.observe( e ); } );
		// Never leave anything hidden if the observer is late.
		setTimeout( function () { seen.forEach( function ( e ) { if ( e.getBoundingClientRect().top < window.innerHeight ) { e.classList.add( 'in' ); } } ); }, 2000 );
	}

	/* ---------- Service panels sink back as the next one slides over ---------- */
	function stack() {
		var cards = $$( '.stack .card' );
		if ( ! cards.length ) { return; }
		$$( '.stack' ).forEach( function ( s ) { s.style.setProperty( '--cards', '"' + $$( '.card', s ).length + '"' ); } );
		if ( reduce || phone ) { return; }
		// Each panel shades by how much of it the next panel covers, read from the layout on every
		// frame, so nothing builds up between refreshes. Barely any shade until it is mostly covered.
		var ins = cards.map( function ( c ) { return $( '.card-in', c ); } );
		var ticking = false;
		function shade() {
			ticking = false;
			for ( var i = 0; i < cards.length; i++ ) {
				var next = cards[ i + 1 ];
				var cover = 0;
				if ( next ) {
					var r = cards[ i ].getBoundingClientRect();
					var n = next.getBoundingClientRect();
					cover = Math.max( 0, Math.min( 1, ( r.bottom - n.top ) / r.height ) );
				}
				ins[ i ].style.setProperty( '--cover', cover.toFixed( 3 ) );
			}
		}
		function queue() { if ( ! ticking ) { ticking = true; requestAnimationFrame( shade ); } }
		window.addEventListener( 'scroll', queue, { passive: true } );
		window.addEventListener( 'resize', queue );
		shade();
	}

	/* ---------- How it works: the picture of the hovered step follows the pointer ---------- */
	function peek() {
		var list = $( '.bands' );
		if ( ! list ) { return; }
		var imgs = $$( '.band-img', list );
		if ( ! imgs.length || ! window.matchMedia( '(hover: hover) and (min-width: 861px)' ).matches ) { return; }
		list.classList.add( 'peekable' );
		var hp = el( 'div', 'how-peek' );
		hp.setAttribute( 'aria-hidden', 'true' );
		imgs.forEach( function ( im ) { var c = el( 'img' ); c.alt = ''; c.loading = 'lazy'; c.src = im.currentSrc || im.src; hp.appendChild( c ); } );
		body.appendChild( hp );
		var pics = $$( 'img', hp );
		var rows = $$( '.band', list );
		var cur = -1;
		var hx = 0, hy = 0, cx = 0, cy = 0, raf = 0;
		// The picture follows the pointer across, but sits on the row above the hovered one (below it
		// for the first row), so it only ever covers dimmed rows, never the step being read.
		function target( x ) {
			var r = rows[ cur ].getBoundingClientRect();
			var L = list.getBoundingClientRect();
			var w = hp.offsetWidth, h = hp.offsetHeight;
			hx = Math.max( L.left, Math.min( L.right - w, x - w / 2 ) );
			hy = cur > 0 ? r.top - h - 12 : r.bottom + 12;
		}
		function loop() {
			cx += ( hx - cx ) * 0.16;
			cy += ( hy - cy ) * 0.16;
			hp.style.transform = 'translate(' + cx.toFixed( 1 ) + 'px,' + cy.toFixed( 1 ) + 'px) rotate(' + Math.max( -3, Math.min( 3, ( hx - cx ) * 0.03 ) ).toFixed( 2 ) + 'deg)';
			raf = Math.abs( hx - cx ) > 0.4 || Math.abs( hy - cy ) > 0.4 ? requestAnimationFrame( loop ) : 0;
		}
		var lastX = 0;
		list.addEventListener( 'pointermove', function ( e ) { lastX = e.clientX; if ( cur < 0 ) { return; } target( lastX ); if ( ! raf ) { raf = requestAnimationFrame( loop ); } } );
		window.addEventListener( 'scroll', function () { if ( cur > -1 && hp.classList.contains( 'show' ) ) { target( lastX ); if ( ! raf ) { raf = requestAnimationFrame( loop ); } } }, { passive: true } );
		rows.forEach( function ( b, i ) {
			b.addEventListener( 'pointerenter', function ( e ) {
				var first = ! hp.classList.contains( 'show' );
				cur = i;
				lastX = e.clientX;
				target( lastX );
				if ( first ) { cx = hx; cy = hy; loop(); } else if ( ! raf ) { raf = requestAnimationFrame( loop ); }
				pics.forEach( function ( im, j ) { im.classList.toggle( 'on', j === i ); } );
				hp.classList.add( 'show' );
			} );
		} );
		list.addEventListener( 'pointerleave', function () { hp.classList.remove( 'show' ); } );
	}

	/* ---------- Gallery filter: tabs from data-filters, each photo's tab in data-cat ---------- */
	function slug( s ) { return s.toLowerCase().replace( /&/g, 'and' ).replace( /[^a-z0-9]+/g, '-' ).replace( /^-|-$/g, '' ); }
	function galleryFilter() {
		var grid = $( '.masonry[data-filters]' );
		if ( ! grid ) { return; }
		var items = $$( '.gal-item', grid );
		var names = grid.getAttribute( 'data-filters' ).split( ',' ).map( function ( s ) { return s.trim(); } ).filter( Boolean );
		var tabs = [ { key: 'all', name: 'All', n: items.length } ];
		names.forEach( function ( name ) {
			var n = items.filter( function ( b ) { return slug( b.getAttribute( 'data-cat' ) || '' ) === slug( name ); } ).length;
			if ( n ) { tabs.push( { key: slug( name ), name: name, n: n } ); }
		} );
		var bar = el( 'div', 'gal-filter', '' );
		bar.setAttribute( 'role', 'group' );
		bar.setAttribute( 'aria-label', 'Filter photos' );
		tabs.forEach( function ( t ) {
			var b = el( 'button', 'gal-tab', '' );
			b.type = 'button';
			b.setAttribute( 'data-key', t.key );
			b.setAttribute( 'aria-pressed', 'false' );
			b.textContent = t.name;
			b.appendChild( el( 'span', '', String( t.n ) ) );
			bar.appendChild( b );
		} );
		grid.parentNode.insertBefore( bar, grid );
		var note = el( 'p', 'gal-note', '' );
		note.setAttribute( 'aria-live', 'polite' );
		bar.appendChild( note );
		var timer = null;
		function apply( key ) {
			var n = 0;
			items.forEach( function ( b ) {
				var on = key === 'all' || slug( b.getAttribute( 'data-cat' ) || '' ) === key;
				b.hidden = ! on;
				b.classList.toggle( 'o2', on && n % 2 === 1 );
				b.classList.toggle( 'o3', on && n % 3 === 1 );
				if ( on ) { n++; }
			} );
			$$( '.gal-tab', bar ).forEach( function ( b ) { b.setAttribute( 'aria-pressed', String( b.getAttribute( 'data-key' ) === key ) ); } );
			note.textContent = n + ' photos';
			if ( window.ScrollTrigger ) { window.ScrollTrigger.refresh(); }
		}
		function pick( key, scroll ) {
			if ( ! tabs.some( function ( t ) { return t.key === key; } ) ) { key = 'all'; }
			history.replaceState( null, '', key === 'all' ? location.pathname + location.search : '#' + key );
			if ( reduce ) { apply( key ); return; }
			clearTimeout( timer );
			grid.classList.add( 'is-out' );
			timer = setTimeout( function () {
				apply( key );
				if ( scroll && bar.getBoundingClientRect().top < 0 ) {
					var y = bar.getBoundingClientRect().top + window.scrollY - offset() - 24;
					if ( lenis ) { lenis.scrollTo( y, { immediate: true } ); } else { window.scrollTo( 0, y ); }
				}
				requestAnimationFrame( function () { grid.classList.remove( 'is-out' ); } );
			}, 220 );
		}
		bar.addEventListener( 'click', function ( e ) {
			var b = e.target.closest( '.gal-tab' );
			if ( b ) { pick( b.getAttribute( 'data-key' ), true ); }
		} );
		// A link to /gallery/#interior opens on that tab, also when it is followed from this page.
		window.addEventListener( 'hashchange', function () { pick( location.hash.slice( 1 ), true ); } );
		apply( tabs.some( function ( t ) { return t.key === location.hash.slice( 1 ); } ) ? location.hash.slice( 1 ) : 'all' );
	}

	/* ---------- Photo viewer for the gallery ---------- */
	function lightbox() {
		var items = $$( '.gal-item' );
		if ( ! items.length ) { return; }
		var lb = el( 'dialog', 'lb', '<div class="lb-stage"><img alt=""></div><button class="icon-btn lb-close" type="button" aria-label="Close"></button><button class="icon-btn lb-prev" type="button" aria-label="Previous photo"></button><button class="icon-btn lb-next" type="button" aria-label="Next photo"></button><div class="lb-bar" aria-live="polite"><span class="lb-cap"></span><span class="lb-count"></span></div>' );
		lb.setAttribute( 'aria-label', 'Photo viewer' );
		body.appendChild( lb );
		var img = $( '.lb-stage img', lb );
		var cur = 0, opener = null;
		// Only the photos the gallery filter leaves visible.
		function shown() { return items.filter( function ( b ) { return ! b.hidden; } ); }
		function show( i ) {
			var list = shown();
			cur = ( i + list.length ) % list.length;
			var t = $( 'img', list[ cur ] );
			img.src = t.currentSrc || t.src;
			img.alt = t.alt;
			$( '.lb-cap', lb ).textContent = ( $( '.cap', list[ cur ] ) || {} ).textContent || '';
			$( '.lb-count', lb ).textContent = ( cur + 1 ) + ' / ' + list.length;
		}
		items.forEach( function ( b ) {
			b.setAttribute( 'role', 'button' );
			b.setAttribute( 'tabindex', '0' );
			var cap = $( '.cap', b );
			b.setAttribute( 'aria-label', 'Open photo: ' + ( cap ? cap.textContent.trim() : ( $( 'img', b ) || {} ).alt || '' ) );
			function open() {
				opener = b;
				show( shown().indexOf( b ) );
				var full = $( 'img', b );
				if ( full && full.srcset ) { var big = full.srcset.split( ',' ).pop().trim().split( ' ' )[ 0 ]; if ( big ) { img.src = big; } }
				if ( lb.showModal ) { lb.showModal(); } else { lb.setAttribute( 'open', '' ); }
				if ( lenis ) { lenis.stop(); }
			}
			b.addEventListener( 'click', open );
			b.addEventListener( 'keydown', function ( e ) { if ( e.key === 'Enter' || e.key === ' ' ) { e.preventDefault(); open(); } } );
		} );
		lb.addEventListener( 'close', function () { if ( lenis ) { lenis.start(); } if ( opener ) { opener.focus(); } } );
		$( '.lb-close', lb ).addEventListener( 'click', function () { lb.close(); } );
		$( '.lb-prev', lb ).addEventListener( 'click', function () { show( cur - 1 ); } );
		$( '.lb-next', lb ).addEventListener( 'click', function () { show( cur + 1 ); } );
		lb.addEventListener( 'click', function ( e ) { if ( e.target === lb || e.target.classList.contains( 'lb-stage' ) ) { lb.close(); } } );
		lb.addEventListener( 'keydown', function ( e ) { if ( e.key === 'ArrowLeft' ) { show( cur - 1 ); } if ( e.key === 'ArrowRight' ) { show( cur + 1 ); } } );
		var sx = null, stage = $( '.lb-stage', lb );
		stage.addEventListener( 'pointerdown', function ( e ) { sx = e.clientX; } );
		stage.addEventListener( 'pointerup', function ( e ) { if ( sx === null ) { return; } var dx = e.clientX - sx; sx = null; if ( Math.abs( dx ) > 48 ) { show( cur + ( dx < 0 ? 1 : -1 ) ); } } );
	}

	/* ---------- Service-area map: towns come from the Locations list ---------- */
	function js( src ) {
		return new Promise( function ( ok, fail ) {
			var s = document.createElement( 'script' );
			s.src = src;
			s.onload = ok;
			s.onerror = fail;
			document.head.appendChild( s );
		} );
	}
	function css( href ) {
		var l = document.createElement( 'link' );
		l.rel = 'stylesheet';
		l.href = href;
		document.head.appendChild( l );
	}
	function serveTiles() {
		var tiles = window.RD_TILES || {};
		var net = window.fetch;
		window.fetch = function ( input ) {
			var u = typeof input === 'string' ? input : input && input.url;
			var hit = u && u.match( /rdmap\/(\d+\/\d+\/\d+)\.mvt/ );
			if ( ! hit ) { return net.apply( this, arguments ); }
			var b64 = tiles[ hit[ 1 ] ];
			if ( ! b64 ) { return Promise.resolve( new Response( new ArrayBuffer( 0 ) ) ); }
			var bin = atob( b64 ), bytes = new Uint8Array( bin.length );
			for ( var i = 0; i < bin.length; i++ ) { bytes[ i ] = bin.charCodeAt( i ); }
			return Promise.resolve( new Response( bytes.buffer ) );
		};
	}
	function map() {
		var box = $( '.map-bz' );
		// map-solo (Get a Quote): the business alone, its name and address on one pin, no towns, no zoom.
		var solo = !! box && box.classList.contains( 'map-solo' );
		var home = D.home || {};
		var towns = solo ? ( home.lat ? [ { name: home.name, lat: home.lat, lng: home.lng, home: true } ] : [] ) : ( D.towns || [] );
		if ( ! box || ! towns.length || ! D.map ) { return; }
		var focus = box.getAttribute( 'data-town' ) || '';
		var holder = $( '.am-map', box );
		if ( ! holder ) { holder = el( 'div', 'am-map' ); box.insertBefore( holder, box.firstChild ); }
		// map-full on a phone: the tile data cannot cover a tall narrow section with every town in view,
		// so the map stays in the stage under the heading.
		var stage = $( '.am-stage', box );
		if ( stage && phone && box.classList.contains( 'map-full' ) ) { stage.insertBefore( holder, stage.firstChild ); }
		var names = solo ? [ home.name, home.address ].filter( Boolean ).join( ', ' ) : towns.map( function ( t ) { return t.name; } ).join( ', ' );
		holder.setAttribute( 'role', 'region' );
		holder.setAttribute( 'aria-label', 'Map of ' + names );
		if ( ! $( '.map-fallback', box ) ) { var fb = el( 'p', 'map-fallback' ); fb.textContent = names; box.appendChild( fb ); }
		var list = $( '.am-list', box );
		if ( list ) {
			list.innerHTML = '';
			list.setAttribute( 'role', 'list' );
			towns.forEach( function ( t ) {
				var li = el( 'li' );
				var b = el( 'button', 'am-item' );
				b.type = 'button';
				b.setAttribute( 'aria-pressed', 'false' );
				b.innerHTML = '<span></span><i aria-hidden="true"></i>';
				b.firstChild.textContent = t.name;
				li.appendChild( b );
				list.appendChild( li );
			} );
		}
		if ( ! solo ) {
			( stage || box ).appendChild( el( 'div', 'am-zoom', '<button type="button" data-zoom="1" aria-label="Zoom in"></button><button type="button" data-zoom="-1" aria-label="Zoom out"></button>' ) );
		}
		var BOUNDS = [ [ 48.86, -123.04 ], [ 49.41, -121.62 ] ];
		var c = { earth: '#ECEAE4', water: '#D3D0C9', river: '#C9C5BD', road: '#DEDAD2', highway: '#CDC7BB', border: '#8E8A82' };
		function build() {
			var L = window.L, P = window.protomapsL, POLY = 3;
			// map-full fades out where the tiles end, so it may show past BOUNDS: otherwise maxBounds would
			// re-centre a section-wide view and push the pins under the panel.
			var full = box.classList.contains( 'map-full' );
			var m = L.map( holder, { zoomControl: false, scrollWheelZoom: false, dragging: ! L.Browser.mobile, minZoom: 8, maxZoom: 12, zoomSnap: 0.25, maxBounds: L.latLngBounds( BOUNDS ).pad( full ? 0.6 : 0 ), maxBoundsViscosity: 1 } );
			m.attributionControl.setPrefix( false );
			P.leafletLayer( {
				url: 'rdmap/{z}/{x}/{y}.mvt', maxDataZoom: 10, minZoom: 8, maxZoom: 12, bounds: L.latLngBounds( BOUNDS ), backgroundColor: c.water, labelRules: [],
				attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="https://protomaps.com">Protomaps</a>',
				paintRules: [
					{ dataLayer: 'earth', symbolizer: new P.PolygonSymbolizer( { fill: c.earth } ) },
					{ dataLayer: 'water', symbolizer: new P.PolygonSymbolizer( { fill: c.water } ), filter: function ( z, f ) { return f.geomType === POLY; } },
					{ dataLayer: 'water', symbolizer: new P.LineSymbolizer( { color: c.river, width: 1.4 } ), filter: function ( z, f ) { return f.geomType !== POLY; } },
					{ dataLayer: 'roads', symbolizer: new P.LineSymbolizer( { color: c.road, width: 1.2 } ), filter: function ( z, f ) { return f.props.kind === 'major_road'; } },
					{ dataLayer: 'roads', symbolizer: new P.LineSymbolizer( { color: c.highway, width: 2 } ), filter: function ( z, f ) { return f.props.kind === 'highway'; } },
					{ dataLayer: 'boundaries', symbolizer: new P.LineSymbolizer( { color: c.border, width: 1, dash: [ 4, 3 ] } ), filter: function ( z, f ) { return f.props.kind === 'country'; } }
				]
			} ).addTo( m );
			var items = $$( '.am-item', box );
			var panel = $( '.am-panel', box );
			var pins = towns.map( function ( t, i ) {
				var home = !! t.home;
				var tag = home ? '<b>Relax Detail, </b>' : '';
				var html = solo
					? '<span class="am-pin am-home am-solo"><i></i><span><b>' + t.name + '</b>' + ( D.home.address ? '<small>' + D.home.address + '</small>' : '' ) + '</span></span>'
					: '<span class="am-pin' + ( home ? ' am-home' : '' ) + '"><i></i><span>' + tag + t.name + '</span></span>';
				var mk = L.marker( [ t.lat, t.lng ], { keyboard: false, interactive: ! solo, riseOnHover: true, zIndexOffset: home ? 1000 : 0, icon: L.divIcon( { className: '', iconSize: [ 0, 0 ], html: html } ) } ).addTo( m );
				mk.on( 'click', function () { if ( t.url && ! home && items.length === 0 ) { location.href = t.url; } else { pick( i ); } } );
				return mk;
			} );
			function pad() {
				var mr = holder.getBoundingClientRect();
				if ( ! panel ) { return { paddingTopLeft: [ 56, 56 ], paddingBottomRight: [ 120, 56 ] }; }
				// map-full: the map fills the section, the pins keep to the stage under the heading.
				var fr = stage ? stage.getBoundingClientRect() : mr;
				var pr = panel.getBoundingClientRect();
				var side = pr.height > fr.height / 2;
				return {
					paddingTopLeft: [ side ? pr.right - mr.left + 48 : fr.left - mr.left + 24, side ? fr.top - mr.top + 64 : pr.bottom - mr.top + 48 ],
					paddingBottomRight: [ mr.right - fr.right + ( stage && side ? 48 : side ? 120 : 124 ), mr.bottom - fr.bottom + 64 ]
				};
			}
			function mark( i ) {
				items.forEach( function ( b, j ) { b.setAttribute( 'aria-pressed', j === i ? 'true' : 'false' ); } );
				pins.forEach( function ( p, j ) { var e = p.getElement(); if ( e ) { e.firstChild.classList.toggle( 'on', j === i && ! towns[ j ].home ); } } );
			}
			function frame() {
				if ( solo ) {
					m.setView( [ towns[ 0 ].lat, towns[ 0 ].lng ], 11, { animate: false } );
					// The pin stands 14px above its point, and exists only once the map has a view: move the
					// map down by half the pin's height plus that gap, so the pin sits in the middle.
					var pe = pins[ 0 ].getElement();
					var lift = pe && pe.firstChild ? pe.firstChild.offsetHeight / 2 + 14 : 0;
					m.panBy( [ 0, -lift ], { animate: false } );
					return;
				}
				m.fitBounds( L.latLngBounds( towns.map( function ( t ) { return [ t.lat, t.lng ]; } ) ), pad() );
			}
			function pick( i ) {
				mark( i );
				var l = items[ i ] && items[ i ].closest( '.am-list' );
				if ( l && l.scrollWidth > l.clientWidth ) { l.scrollTo( { left: items[ i ].offsetLeft - 8, behavior: reduce ? 'auto' : 'smooth' } ); }
				var o = pad();
				var shift = L.point( ( o.paddingTopLeft[ 0 ] - o.paddingBottomRight[ 0 ] ) / 2, ( o.paddingTopLeft[ 1 ] - o.paddingBottomRight[ 1 ] ) / 2 );
				m.flyTo( m.unproject( m.project( [ towns[ i ].lat, towns[ i ].lng ], 11 ).subtract( shift ), 11 ), 11, { duration: reduce ? 0 : 0.9 } );
			}
			items.forEach( function ( b, i ) { b.addEventListener( 'click', function () { if ( b.getAttribute( 'aria-pressed' ) === 'true' ) { mark( -1 ); frame(); } else { pick( i ); } } ); } );
			$$( '[data-zoom]', box ).forEach( function ( z ) { z.addEventListener( 'click', function () { m.setZoom( m.getZoom() + Number( z.dataset.zoom ) ); } ); } );
			var fi = -1;
			towns.forEach( function ( t, i ) { if ( focus && t.slug === focus ) { fi = i; } } );
			// map-full: the tile data ends at BOUNDS, inside the section; the map is masked to fade out there
			// (rd.css), and the credit moves out of the mask so it always shows.
			if ( full ) {
				( phone && stage ? stage : box ).appendChild( m.attributionControl.getContainer() );
				var edge = function () {
					var nw = m.latLngToContainerPoint( [ BOUNDS[ 1 ][ 0 ], BOUNDS[ 0 ][ 1 ] ] ), se = m.latLngToContainerPoint( [ BOUNDS[ 0 ][ 0 ], BOUNDS[ 1 ][ 1 ] ] );
					holder.style.setProperty( '--x0', Math.round( nw.x ) + 'px' );
					holder.style.setProperty( '--y0', Math.round( nw.y ) + 'px' );
					holder.style.setProperty( '--x1', Math.round( se.x ) + 'px' );
					holder.style.setProperty( '--y1', Math.round( se.y ) + 'px' );
				};
				m.on( 'move zoom resize', edge );
			}
			frame();
			if ( fi > -1 ) { setTimeout( function () { pick( fi ); }, 60 ); }
			window.addEventListener( 'resize', function () { m.invalidateSize(); if ( solo ) { frame(); } } );
			box.classList.add( 'ready' );
		}
		var started = false;
		function start() {
			if ( started ) { return; }
			started = true;
			css( D.map.css );
			js( D.map.tiles ).then( serveTiles ).then( function () { return js( D.map.leaflet ); } ).then( function () { return js( D.map.protomaps ); } ).then( build ).catch( function () {} );
		}
		if ( 'IntersectionObserver' in window ) {
			new IntersectionObserver( function ( es, o ) { if ( es[ 0 ].isIntersecting ) { o.disconnect(); start(); } }, { rootMargin: '600px 0px' } ).observe( box );
		} else {
			start();
		}
	}

	/* ---------- Compare tables: each cell carries its column's name, for the stacked phone layout ---------- */
	function tables() {
		$$( '.cmp table' ).forEach( function ( t ) {
			var heads = $$( 'thead th', t ).map( function ( th ) { return th.textContent.trim(); } );
			$$( 'tbody tr', t ).forEach( function ( tr ) {
				$$( 'td', tr ).forEach( function ( td, i ) { td.setAttribute( 'data-th', heads[ i + 1 ] || '' ); } );
			} );
		} );
	}

	/* ---------- Legal pages: contents list from the numbered clause headings ---------- */
	function toc() {
		var box = $( '.legal-toc' );
		var heads = $$( '.legal-clause > :is(h2, h3)' );
		if ( ! box || ! heads.length ) { return; }
		var ol = el( 'ol' );
		var links = heads.map( function ( hd, i ) {
			var clause = hd.parentElement;
			var text = hd.textContent.trim();
			var m = text.match( /^(\d+)\.\s*(.*)$/ );
			if ( ! clause.id ) { clause.id = 'clause-' + ( m ? m[ 1 ] : i + 1 ) + '-' + ( m ? m[ 2 ] : text ).toLowerCase().replace( /[^a-z0-9]+/g, '-' ).replace( /^-|-$/g, '' ); }
			var li = el( 'li' );
			var a = el( 'a' );
			a.href = '#' + clause.id;
			a.innerHTML = '<b></b><span></span>';
			a.firstChild.textContent = m ? m[ 1 ].padStart( 2, '0' ) : '';
			a.lastChild.textContent = m ? m[ 2 ] : text;
			li.appendChild( a );
			ol.appendChild( li );
			return a;
		} );
		box.appendChild( ol );
		// The clause whose top has passed 30% of the window is the current one.
		var ticking = false;
		function mark() {
			ticking = false;
			var line = window.innerHeight * 0.3, cur = 0;
			heads.forEach( function ( hd, i ) { if ( hd.parentElement.getBoundingClientRect().top <= line ) { cur = i; } } );
			links.forEach( function ( a, i ) { if ( i === cur ) { a.setAttribute( 'aria-current', 'true' ); } else { a.removeAttribute( 'aria-current' ); } } );
		}
		window.addEventListener( 'scroll', function () { if ( ! ticking ) { ticking = true; requestAnimationFrame( mark ); } }, { passive: true } );
		mark();
	}

	/* ---------- Header: transparent over the hero, back on scroll up once the hero is passed ---------- */
	function pin() {
		var hd = $( '.hd' );
		if ( ! hd ) { return; }
		var last = window.scrollY;
		var pinned = false;
		var ticking = false;
		// The hero's end: the film's pin spacer on the home page (the film scrolls several screens), else the page hero.
		function heroEnd() {
			var hero = $( '.film' ) || $( '.page-hero' );
			if ( ! hero ) { return hd.offsetHeight; }
			return ( hero.closest( '.pin-spacer' ) || hero ).getBoundingClientRect().bottom + window.scrollY;
		}
		function show( on ) { hd.classList.toggle( 'hd-show', on ); }
		function update() {
			ticking = false;
			var y = window.scrollY;
			var dy = y - last;
			last = y;
			if ( y <= 0 ) {
				// Back at the top: the fixed bar and the bar in the page sit in the same place, so the swap is not seen.
				pinned = false;
				hd.classList.remove( 'hd-pin', 'hd-anim', 'hd-show' );
				hd.style.setProperty( '--hd-fade', '1' );
				return;
			}
			if ( ! pinned ) {
				// The fade behind the bar is gone by the time the bar has scrolled two of its heights.
				hd.style.setProperty( '--hd-fade', Math.max( 0, 1 - y / ( hd.offsetHeight * 2 ) ).toFixed( 3 ) );
				if ( y < heroEnd() ) { return; }
				// Passed the hero: fix the bar out of sight, and let it slide only from the next frame on.
				pinned = true;
				hd.classList.add( 'hd-pin' );
				requestAnimationFrame( function () { hd.classList.add( 'hd-anim' ); } );
				return;
			}
			if ( dy < 0 ) { show( true ); } else if ( dy > 0 && ! hd.contains( document.activeElement ) ) { show( false ); }
		}
		window.addEventListener( 'scroll', function () { if ( ! ticking ) { ticking = true; requestAnimationFrame( update ); } }, { passive: true } );
		hd.addEventListener( 'focusin', function () { if ( pinned ) { show( true ); } } );
		update();
	}

	startLenis();
	anchors();
	header();
	pin();
	film();
	door();
	reveals();
	stack();
	peek();
	galleryFilter();
	lightbox();
	map();
	toc();
	tables();
	if ( window.ScrollTrigger ) { window.addEventListener( 'load', function () { window.ScrollTrigger.refresh(); } ); }
}() );
